module.exports = __webpack_public_path__ + "img/do.79f8bf8c.svg";